import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { updateGroupMinSiteRole } from '../actions/GroupMenuActions';
import { IGroupInfo } from '../models/IGroupInfo';

export const GroupsUpdateMinimumSiteRoleAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.UpdateGroupMinimumSiteRole,
  translateName: Messages.minimumSiteRole_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    const isGroupsSpace = state.spaceInfo.spaceType === 'groups';
    const isVisibleWithLUL = hasADGroupsOnly(targetItems);
    return targetItems.length >= 1
      && (isVisibleWithLUL)
      && isGroupsSpace;
  },
  isClickable: (availableActions: {}, targetItems: {}, state: AppState) =>
    SessionUserSelectors.canManageUsers(state) || SessionServerSelectors.isAdminProfilesEnabledOnServer(state),
  createReduxAction: (targetItems: IGroupInfo[]) => updateGroupMinSiteRole(targetItems)
};

function hasADGroups(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => isActiveDirectoryGroup(group)).length;
  return result >= 1;
}

function hasADGroupsOnly(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => isActiveDirectoryGroup(group)).length;
  return result === groups.length;
}

function isActiveDirectoryGroup(group: IGroupInfo): boolean {
  return (group.domainName && group.domainName !== 'local');
}
